import {AsyncFn} from '../common/functions/AsyncFn';

export function isAsyncFunction(o?: any): o is AsyncFn {
    return typeof o === 'function'
        && o.constructor.name === 'AsyncFunction';
}